module.exports = __webpack_public_path__ + "images/kurtosis-07-desktop.png";